export default __webpack_public_path__ + "static/media/comment.inline.0e524345.svg";